import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'components/LazyLoad/LazyLoad';
import Toolkit from '../Toolkit/Toolkit';
import styles from './JobsBoardBannerAd.module.scss';
import config from '../../../config';

const getImage = (image = '') => {
  return `${config.partnerImages}/${image}`;
};

const JobsBoardBannerAd = ({ advert = null }) => {
  return advert ? (
    <Fragment>
      <div className={styles.container}>
        <a href={advert.link_destination} target="_blank" rel="noreferrer">
          <LazyLoad>
            <img
              className={`${styles.image} ${styles.desktopImage}`}
              src={getImage(advert.desktop_image)}
              alt={advert.partner_name}
            />
          </LazyLoad>
          <LazyLoad>
            <img
              className={`${styles.image} ${styles.mobileImage}`}
              src={getImage(advert.mobile_image)}
              alt={advert.partner_name}
            />
          </LazyLoad>
        </a>
      </div>
    </Fragment>
  ) : (
    <Toolkit />
  );
};

JobsBoardBannerAd.propTypes = {
  advert: PropTypes.object,
};

export default JobsBoardBannerAd;
